export default __webpack_public_path__ + "static/38-30ce15ae0403fd02f09e56f457d5b8e4.png";